/**
 * Utilidades de normalización (nomenclatura Adder).
 *
 * Adder normaliza los nombres de máquinas a MAYÚSCULAS, mientras que
 * Ubuntu (política de hostname) los crea en minúsculas. Para que una misma
 * máquina (p.ej. `srvadco00od001` y `SRVADCO00OD001`) se trate y muestre
 * igual, comparamos y mostramos siempre en mayúsculas.
 */

/** Normaliza un nombre a mayúsculas (nomenclatura Adder), con trim. */
export function upperName(name) {
  return String(name || '').trim().toUpperCase();
}

/** Compara dos nombres ignorando mayúsculas/minúsculas y espacios. */
export function sameName(a, b) {
  return upperName(a) === upperName(b);
}
